/* eslint-disable graphql/template-strings */
/* eslint-disable max-len */
import { Injectable } from '@angular/core';
import { DocumentNode } from 'graphql';
import * as apollo from 'apollo-link';
import { gql } from 'graphql-tag';
import { filter, first } from 'rxjs/operators';
import {
  ConnextSN,
} from '..';

import { GraphqlApiService } from '../../graphql-api/graphql-api.service';

export interface GetConnextSnByIdInput {
  id?: string;
}
const build = (_query: DocumentNode, input: GetConnextSnByIdInput, name = 'QueryResult') => {
  const bQuery = `
  query ${ name }(`+
    ( input.id !== undefined ? `$id: String = ${JSON.stringify(input.id).replace(/"(\w+)":/g, '$1:')}` : '' ) + `){
    getConnextSnById(
      ${ input.id !== undefined ? 'id: $id,' : '' }
    ){
      ...connextsn
    }
  }`;
  return gql`
  ${bQuery}
  ${_query}
`};

@Injectable({
  providedIn: 'root',
})
export class GetConnextSnByIdQuery {
  readonly graphqlClient$ = this.graphqlApiService.client$.pipe(
    filter((available) => !!available),
  );

  readonly build = build;

  constructor(
    private readonly graphqlApiService: GraphqlApiService,
  ) { }

  /**
   * fragment connextsn on ConnextSN { ... }
   */
  async execute(_query: DocumentNode, input: GetConnextSnByIdInput, refresh = false) {
    const client = await this.graphqlClient$.pipe(first()).toPromise();
    if (!client) {
      throw Error('Missing graphql client!');
    }
    const fetchPolicy = refresh ? 'network-only' : 'cache-first';
   return await client?.query<{ getConnextSnById: Partial<ConnextSN> }>({ query: build(_query, input), fetchPolicy });
  }
}
